import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useDashboardStore } from "./store/dashboardStore";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF8400",
    },
  },
});

export const ErrorWarningTabs = () => {
  // Get state and actions directly from the store
  const { dashboardTotal, setActiveTab, setPage } = useDashboardStore();
  const [clickedTab, setClickedTab] = React.useState("one");

  return (
    <Box>
      <ThemeProvider theme={theme}>
        <Tabs
          value={clickedTab}
          onChange={(event, tabValue) => {
            setClickedTab(tabValue);
            if (tabValue === "one") {
              setPage(0);
              setActiveTab("error");
            }
            if (tabValue === "two") {
              setPage(0);
              setActiveTab("warning");
            }
          }}
          aria-label="tabs"
          color="primary"
          variant="fullWidth"
          sx={{ width: "100%", maxWidth: "600px" }}
        >
          <Tab
            value="one"
            label={`Error ${
              dashboardTotal.error ? `(${dashboardTotal.error})` : `(0)`
            }`}
            sx={{ fontFamily: "Mulish", fontWeight: "Bold", color: "primary" }}
          />
          <Tab
            value="two"
            label={`Warning ${
              dashboardTotal.warning ? `(${dashboardTotal.warning})` : `(0)`
            }`}
            sx={{ fontFamily: "Mulish", fontWeight: "Bold", color: "primary" }}
          />
        </Tabs>
      </ThemeProvider>
    </Box>
  );
};
